module.exports = __webpack_public_path__ + "img/a04dd9c1073943cc8ad8480eaf4e44a3.00b818c2.png";